import "./SlideLabelAndSource.css";

import { useSelector } from "react-redux";

import { Specimen } from "pwapi";

import { SlideDetailState } from "shared/reducers/slideDetailReducer";
import { FeatureFlags } from "shared/reducers/sysReducer";
import { slideDetailLabel } from "shared/utils/slideUtils";
import { specimen_source } from "shared/utils/specimenUtils";

import ApplicationState from "store/ApplicationState";
import { useAppSelector } from "store/hooks";

export const SlideLabelAndSource = ({
  slideDetailObject,
  specimen,
}: {
  slideDetailObject: SlideDetailState;
  specimen: Specimen;
}) => {
  const features: FeatureFlags = useSelector(
    ({ sys }: ApplicationState) => sys.features
  );
  const stain = useAppSelector(
    ({ stains }) => stains[slideDetailObject.stain_id || 0]
  );

  return (
    <strong className="SlideLabel">
      {!!slideDetailObject.id
        ? slideDetailLabel(slideDetailObject, stain, true)
        : specimen?.name || ""}
      {features?.signOutInViewer && specimen && (
        <span className="SlideLabel__source">
          {" "}
          ({specimen_source(specimen)})
        </span>
      )}
    </strong>
  );
};
